import Header from './components/Header';
import Hero from './components/Hero';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />

        <CommentsSection />

        <CardsSection />

        <ContactSection />

        <RankingSection />

        <TopicsSection />

        <CarouselSection />

        <IndexSection />

        <AboutSection />

        <UpdatesSection />

        <AppSection />

        <MediaSection />

        <FAQSection />

        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}